import type { ExplorerOnboardingPayload } from "../api/explorerOnboardingApi";

export type ExplorerMeResponse = {
  explorer?: unknown | null;
  payload?: ExplorerOnboardingPayload | null;
};

/**
 * True when GET /ExplorerOnboarding/me returns an Explorer row and/or onboarding payload.
 */
export function hasExplorerOnboarding(
  data: ExplorerMeResponse | undefined | null
): boolean {
  if (!data) return false;
  if (data.explorer != null) return true;
  const p = data.payload;
  if (!p) return false;
  return !!(p.completedUtc || p.segment || p.flowType);
}
